<template>
    <v-container>
      <vueHeadful
      :title="this.$i18n.t('Menu.FavoritosPerfil') + ' - TrArtist'"
      :url="'https://trartist.com' + $route.fullPath"
      />
        <v-row>
            <v-col cols="12" align="center" class="mb-5">
                <h1 class="titulo">{{$t('Menu.FavoritosPerfil')}}</h1>
            </v-col>
            <v-col cols="12" xs="12" sm="4" v-for="(i, index) in productos" :key="i.uid">
                  <v-row>
                    <v-col cols="12" @click="verProducto(i.uid)">
                      <div style="background: black;">
                        <v-hover v-slot:default="{ hover }">
                          <v-img :id="hover ? 'imagen' : ''" :src="i.imagenPrincipal" width="100%" aspect-ratio="1"/>
                        </v-hover>
                      </div>
                    </v-col>
                    <v-col cols="9" class="py-0">
                      <v-row>
                        <v-col cols="12" class="pb-0">
                          <span style="font-size:15px;">{{ i.titulo.toUpperCase() }}</span>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <router-link :to="'/u/'+i.artista.nombreDeUsuario" target= '_blank'>
                          <span style="font-size:15px;">{{ i.artista.nombre }}</span>
                          </router-link>
                        </v-col>
                        <v-col cols="12" class="py-0">
                          <span style="font-size:15px;color:#bdbdbd;">{{ $t('Busqueda.Largo')}} {{ i.dimensiones.largo }}cm x {{ $t('Busqueda.Ancho')}} {{ i.dimensiones.ancho }}cm x {{ $t('Busqueda.Alto')}} {{ i.dimensiones.alto }}cm</span>
                        </v-col>
                        <v-col cols="12" class="pb-0 pt-4" v-if="i.fisico">
                          <span style="font-size:15px;" class="font-weight-bold black--text">${{ Number(i.precioFisico).toLocaleString() }}</span>
                        </v-col>
                        <v-col cols="12" class="pb-0 pt-4" v-if="i.digital">
                          <span style="font-size:15px;" class="font-weight-bold black--text">${{ Number(i.precioDigital).toLocaleString() }}</span>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="3" class="pa-0">
                      <v-row class="pa-0">
                        <v-col cols="6" class="pa-0" align="right">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" icon @click="noMeGusta({uid: i.uid, index})" color="red"><v-icon>fas fa-heart</v-icon></v-btn>
                            </template>
                            <span>{{$t('Inicio.Favorito')}}</span>
                          </v-tooltip>
                        </v-col>
                        <v-col cols="6" class="pa-0">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon color="black" @click="verProducto(i.uid)"><v-icon>fas fa-shopping-cart</v-icon></v-btn>
                            </template>
                            <span>{{$t('Inicio.VerProducto')}}</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import firebase from 'firebase/app'
import 'firebase/firestore'
export default {
  name: 'Favoritos',
  data () {
    return {
      productos: []
    }
  },
  computed: {
    ...mapGetters(['getUsuario'])
  },
  methods: {
    ...mapMutations(['setAlerta', 'setTextoAlerta']),
    verProducto (uid) {
      this.$router.push('/p/' + uid)
    },
    noMeGusta (info) {
      firebase.firestore().collection('usuarios').doc(this.getUsuario.uid).update({
        favoritos: firebase.firestore.FieldValue.arrayRemove(info.uid)
      })
      firebase.firestore().collection('productos').doc(info.uid).update({
        meGusta: firebase.firestore.FieldValue.increment(-1)
      })
      this.productos.splice(info.index, 1)
      this.setAlerta()
      this.setTextoAlerta('Alerta.NoMeGusta')
    }
  },
  mounted () {
    var favoritos = this.getUsuario.favoritos
    for (let i = 0; i < favoritos.length; i++) {
      firebase.firestore().collection('productos').doc(favoritos[i]).get().then(info => {
        this.productos.push(info.data())
      })
    }
  }
}
</script>
